;(function () {
  'use strict'

  angular.module('contrast.licenses-activity-series').factory(
    'chartLicensesActivityBuilderService',
    // eslint-disable-next-line angular/di-unused
    function chartLicensesActivityBuilderServiceFactory(
      csTemplates,
      $translate,
      $q,
      _,
      ServiceUtils,
      Highcharts,
      highchartsSeriesBuilderService,
      highchartsColorService,
      highchartsTooltipBuilderService,
      HIGHCHARTS_COLORS,
      HIGHCHARTS_Z_INDEX,
      CHART_SERIES_ID,
      CHART_ID,
      CHART_EVENTS,
      CHART_CONFIG_ID
    ) {
      'ngInject'

      return {
        buildLicensesActivityChart: buildLicensesActivityChart
      }

      function buildLicensesActivityChart(
        scope,
        element,
        parentChart,
        width,
        config
      ) {
        var tplConfig = {
          xAxisLabelTpl:
            'components/licenses-activity-series/x-axis-label.tpl.html',
          plotLineLabelTpl:
            'components/licenses-activity-series/plot-line-label.tpl.html',
          plotLineInvisibleLabelTpl:
            'components/licenses-activity-series/plot-line-invisible-label.tpl.html',
          licensesActivityTooltipTpl:
            'components/licenses-activity-series/licenses-activity-tooltip.tpl.html',
          drilldownTooltipTpl:
            'components/licenses-activity-series/drilldown-tooltip.tpl.html'
        }

        var tplPromises = _.mapValues(tplConfig, function (tplURL) {
          return csTemplates.load(tplURL)
        })

        return $q
          .all(tplPromises)
          .then(function (templates) {
            var seriesAnimationCompleted = 0

            var plotLines = _buildPlotLines(
              config.yAxis.plotLinesConfig,
              templates.plotLineLabelTpl,
              templates.plotLineInvisibleLabelTpl
            )

            var series = _buildSeries(
              parentChart,
              scope,
              config.yAxis.seriesConfig,
              config.xAxis.values,
              config.data.maxTotalLicensesValue,
              config.xAxis.startValue
            )

            var tooltipConfig =
              highchartsTooltipBuilderService.buildTooltipConfig()
            _addTooltipFormatter(
              tooltipConfig,
              templates.licensesActivityTooltipTpl,
              templates.drilldownTooltipTpl
            )

            var options = {
              firstAnimationFinished: false,
              /* Start Block of Chart Configurations*/
              chart: {
                width: width
              },
              plotOptions: {
                series: {
                  events: {
                    afterAnimate: function () {
                      if (!this.chart.firstAnimationFinished) {
                        seriesAnimationCompleted++
                        if (
                          seriesAnimationCompleted == this.chart.series.length
                        ) {
                          this.chart.firstAnimationFinished = true
                          this.chart.hideLoading()
                        }
                      }
                    }
                  }
                }
              },
              tooltip: tooltipConfig,
              /* End Block of Chart Configurations*/

              /* Start Block of Axis Data Initialization*/
              xAxis: {
                tickPositions: config.xAxis.values,
                labels: {
                  useHTML: true,
                  formatter: function () {
                    return csTemplates.interpolate(templates.xAxisLabelTpl, {
                      date: config.xAxis.formatFunction(new Date(this.value))
                    })
                  }
                }
              },
              yAxis: {
                min: -0.2,
                startOnTick: false,
                plotLines: plotLines
              },
              series: series
              /* End Block of Axis Data Initialization*/
            }

            parentChart = new Highcharts.Chart(element, options)
            parentChart.showLoading()
            return parentChart
          })
          .catch(ServiceUtils.handleError)
      }

      function _buildSeries(
        parentChart,
        scope,
        seriesConfigs,
        xAxisValues,
        maxTotalLicensesValue,
        startXPoint
      ) {
        var series = []

        angular.forEach(seriesConfigs, function (config) {
          //build the Highcharts Series depending on the config type
          switch (config.id) {
            //Protect chart needs a special Drill-down configuration
            case CHART_CONFIG_ID.PROTECT_SERIES_CONFIG:
              _buildProtectSeries(
                scope,
                parentChart,
                series,
                xAxisValues,
                config
              )
              break
            case CHART_CONFIG_ID.ASSESS_SERIES_CONFIG:
            default:
              _buildAssessSeries(series, xAxisValues, config)
              break
          }
        })

        // add an extra Series element (an invisible point) in order to adjust the Y Axis size and be sure about always displaying the Tallest Plot Line
        series.push(
          highchartsSeriesBuilderService.buildSinglePointScatterSeries(
            startXPoint,
            maxTotalLicensesValue
          )
        )

        return series
      }

      function _buildPlotLines(
        plotLinesConfigs,
        plotLineLabelTpl,
        plotLineInvisibleTpl
      ) {
        var plotLines = []
        angular.forEach(plotLinesConfigs, function (config) {
          plotLines.push(
            highchartsSeriesBuilderService.buildPlotLine(
              config.value,
              config.color,
              config.tooltip.message,
              plotLineLabelTpl
            )
          )
          plotLines.push(
            highchartsSeriesBuilderService.buildInvisiblePlotLine(
              config.value,
              config.color,
              config.tooltip.message,
              plotLineInvisibleTpl
            )
          )
        })
        return plotLines
      }

      function _buildProtectSeries(
        scope,
        parentChart,
        seriesList,
        xAxisValues,
        config
      ) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return [xAxisValue, config.values[index]]
        })

        // render the trend line
        var scatterSeries = highchartsSeriesBuilderService.buildScatterSeries(
          CHART_SERIES_ID.PROTECT_LICENSES_ACTIVITY,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.MIDDLE,
          config
        )
        // render the gradient area
        var areaSeries = highchartsSeriesBuilderService.buildAreaSeries(
          CHART_SERIES_ID.PROTECT_LICENSES_ACTIVITY_AREA,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.BOTTOM,
          0.1,
          0,
          config
        )

        _addSeriesDrilldownConfig(
          scope,
          areaSeries,
          config.drilldown,
          CHART_SERIES_ID.PROTECT_LICENSES_ACTIVITY_AREA,
          CHART_SERIES_ID.PROTECT_LICENSES_ACTIVITY,
          config.drilldown.plotLine.value
        )

        seriesList.push(scatterSeries, areaSeries)
      }

      function _buildAssessSeries(seriesList, xAxisValues, config) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return [xAxisValue, config.values[index]]
        })

        // render the trend line
        var scatterSeries = highchartsSeriesBuilderService.buildScatterSeries(
          CHART_SERIES_ID.ASSESS_LICENSES_ACTIVITY,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.MIDDLE,
          config
        )
        // render the gradient area
        var areaSeries = highchartsSeriesBuilderService.buildAreaSeries(
          CHART_SERIES_ID.ASSESS_LICENSES_ACTIVITY_AREA,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.BOTTOM,
          0.1,
          0,
          config
        )
        // remove all the events in the gradient area
        highchartsSeriesBuilderService.disableSeriesTrackingConfig(areaSeries)

        seriesList.push(scatterSeries, areaSeries)
      }

      function _addSeriesDrilldownConfig(
        scope,
        series,
        drilldownConfig,
        seriesId,
        linkedSeriesId,
        totalProtectLicenses
      ) {
        // include the drilldown events in the gradient area

        angular.extend(series, {
          tooltip: {
            followPointer: true,
            followTouchMove: true
          },
          cursor: 'pointer',
          trackByArea: true,
          stickyTracking: false,
          lineWidth: 0,
          states: {
            hover: {
              enabled: false
            }
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          },
          events: {
            mouseOver: function () {
              highchartsColorService.setDisabledSeriesColor(this.chart.series)

              highchartsColorService.setHoverSeriesColor([
                this.chart.get(seriesId),
                this.chart.get(linkedSeriesId)
              ])
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            mouseOut: function () {
              highchartsColorService.setDefaultSeriesColor(this.chart.series)
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            click: function () {
              scope.$emit(
                CHART_EVENTS.DRILLDOWN_LICENSE_ACTIVITY_TO_AGENT_USAGE,
                {
                  totalProtectLicenses: totalProtectLicenses
                }
              )
            }
          }
        })
      }

      function _addTooltipFormatter(
        tooltipConfig,
        tooltipTpl,
        drilldownTooltipTpl
      ) {
        var drilldownSeriesId = CHART_SERIES_ID.PROTECT_LICENSES_ACTIVITY_AREA

        highchartsTooltipBuilderService.setTooltipBgEqualsToSeriesColor(
          tooltipConfig,
          drilldownSeriesId
        )

        tooltipConfig.formatter = function () {
          if (this.series.options.id === drilldownSeriesId) {
            return csTemplates.interpolate(drilldownTooltipTpl, {
              message: this.series.options.rawConfig.drilldown.tooltip.message
            })
          } else {
            return csTemplates.interpolate(tooltipTpl, {
              message: this.series.options.rawConfig.tooltip.message,
              yValue: this.point.y
            })
          }
        }
      }
    }
  )
})()
